import React from 'react';
import './StatsCard.css';

interface StatsCardProps {
  title: string;
  value: string;
  icon: React.ReactNode;
  color: 'orange' | 'blue' | 'green' | 'purple' | 'red';
  trend?: {
    label: string;
    type: 'increase' | 'decrease' | 'neutral';
  };
  change?: string;
  changeType?: 'increase' | 'decrease' | 'neutral';
  footerMetrics?: {
    label: string;
    value: string;
    type?: 'increase' | 'decrease' | 'neutral';
  }[];
  className?: string;
}

const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  icon,
  color,
  trend,
  change,
  changeType,
  footerMetrics,
  className = ''
}) => {
  return (
    <div className={`premium-stats-card stats-card--${color} ${className}`}>
      <div className="card-top">
        <div className="card-icon-wrapper">
          {icon}
        </div>
        {(trend || change) && (
          <div className={`trend-pill trend--${trend?.type || changeType || 'neutral'}`}>
            {trend?.label || change}
          </div>
        )}
      </div>

      <div className="card-main">
        <div className="card-title-small">{title}</div>
        <div className="card-large-value">{value}</div>
      </div>

      {footerMetrics && footerMetrics.length > 0 && (
        <div className="card-footer-metrics">
          {footerMetrics.map((metric, idx) => (
            <div key={idx} className={`footer-metric ${idx === footerMetrics.length - 1 ? 'text-right' : ''}`}>
              <span className="metric-label">{metric.label}</span>
              <span className={`metric-value ${metric.type ? `metric--${metric.type}` : ''}`}>
                {metric.value}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StatsCard;
